import Icon from './Icon.component';
export default Icon;